import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BasketItem,
  addItem,
  selectorBasketById,
} from "../../redux/slices/basketSlice";
import { Link } from "react-router-dom";

type BurgerBlockProps = {
  id: string;
  title: string;
  imageUrl: string;
  sizes: number[];
  types: string[];
  typeNames: string[];
  price: number[];
};

const BurgerBlock: React.FC<BurgerBlockProps> = ({
  id,
  title,
  imageUrl,
  sizes,
  types,
  typeNames,
  price,
}) => {
  const dispatch = useDispatch();
  const basketItem = useSelector(selectorBasketById(id));

  const [activeTypes, setActiveTypes] = React.useState(0);
  const [activeSizes, setActiveSizes] = React.useState(0);

  const showCount = basketItem ? basketItem.count : "";
  const showPrice = price.find((_, id) => id === activeSizes);

  const onClickAdd = () => {
    const item: BasketItem = {
      id,
      title,
      imageUrl,
      price: Number(showPrice),
      type: typeNames[activeTypes],
      size: sizes[activeSizes],
      count: 0,
    };
    dispatch(addItem(item));
  };

  const onClickTypes = (index: number) => {
    setActiveTypes(index);
  };
  const onClickSizes = (index: number) => {
    setActiveSizes(index);
  };

  const showTypes = types.map((typeIndex: any) => (
    <li
      key={typeIndex}
      onClick={() => onClickTypes(typeIndex)}
      className={typeIndex === activeTypes ? "active" : ""}
    >
      {typeNames[typeIndex]}
    </li>
  ));

  const showSizes = sizes.map((size, index) => (
    <li
      key={size}
      onClick={() => onClickSizes(index)}
      className={index === activeSizes ? "active" : ""}
    >
      {size} gr.
    </li>
  ));

  return (
    <div className="pizza-block">
      <Link to={`/burger/${id}`}>
        <img className="pizza-block__image" src={imageUrl} alt="Gumburger" />
      </Link>

      <h4 className="pizza-block__title">{title}</h4>
      <div className="pizza-block__selector">
        <ul>{showTypes}</ul>
        <ul>{showSizes}</ul>
      </div>
      <div className="pizza-block__bottom">
        <div className="pizza-block__price">{showPrice} UAH</div>
        <div
          onClick={onClickAdd}
          className="button button--outline button--add"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8 4.8H7.2V1.2C7.2 0.5373 6.6627 0 6 0C5.3373 0 4.8 0.5373 4.8 1.2V4.8H1.2C0.5373 4.8 0 5.3373 0 6C0 6.6627 0.5373 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.3373 12 6 12C6.6627 12 7.2 11.4627 7.2 10.8V7.2H10.8C11.4627 7.2 12 6.6627 12 6C12 5.3373 11.4627 4.8 10.8 4.8Z"
              fill="white"
            />
          </svg>
          <span>Add</span>
          {showCount && <i>{showCount}</i>}
        </div>
      </div>
    </div>
  );
};

export default BurgerBlock;
